export default [
  { title: "Transaction History", icon: "ri-file-edit-line", link: "/history-money" },
];
